import InitApi from "api/InitApi";
import {
	activateBook,
	BOOK_UPLOAD_STEPS,
	hasBookFileFields,
	pickBookFiles,
	uploadBookFiles,
} from "api/BookResource/bookFileUpload";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useUploadBookFiles = (bookId, { onStepChange, activateAfterUpload = false } = {}) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	return useMutation(
		async (files) => {
			const payload = pickBookFiles(files);

			if (!bookId || !hasBookFileFields(payload)) {
				return null;
			}

			const instance = await InitApi({ accessToken }, "multipart/form-data");

			try {
				onStepChange?.(BOOK_UPLOAD_STEPS.UPLOADING_FILES);
				await uploadBookFiles(instance, bookId, payload);

				if (
					activateAfterUpload &&
					payload.book_cover &&
					payload.book_file
				) {
					onStepChange?.(BOOK_UPLOAD_STEPS.ACTIVATING);
					await activateBook(instance, bookId);
				}

				await Promise.all([
					queryClient.invalidateQueries("books"),
					queryClient.invalidateQueries("myUploadedBooks"),
				]);

				return true;
			} finally {
				onStepChange?.(null);
			}
		},
		{
			onSuccess: async () => {
				toast.success(
					activateAfterUpload
						? "Files uploaded and book activated"
						: "Files uploaded successfully"
				);
			},
			onError: async (error) => {
				toast.error(
					<ServerErrors
						errorMessage={error?.response?.data?.message}
						errors={error?.response?.data?.data}
					/>,
					{ className: "max-w-max" }
				);

				if (error?.response?.data.message === "Unauthenticated.") {
					reactLocalStorage.clear();
					history.push("/");
				}
			},
		}
	);
};

export default useUploadBookFiles;
